// No 'use client' — server components import these to size the column.
export const cardWidth = '26.25rem'
/** Mobile only — on md+ the card fills the row height set by the carousel column. */
export const cardHeight = '35rem'
